<template lang="pug">
UiCardSection
  UiStack
    UiStackItem(fill)
      h4 {{ $t("companies.tabs.billing") }}
  RestTable(
    :headers="headers"
    disablePagination
    namespace="company_billing"
    :fetch-handler="getData"
    embed
  )
</template>
<script>
import ApiCompanies from "@/api/companies.js";

export default {
  data() {
    return {
      headers: [
        {
          key: "month",
          label: "Month",
          sortable: false,
          squeeze: false,
        },
        {
          key: "invoices_count",
          label: "Invoices",
          sortable: false,
          squeeze: false,
        },
        {
          key: "correct_invoices_count",
          label: "100% correct suggested Invoices",
          sortable: false,
          squeeze: false,
        },
        {
          key: "billable_invoices_count",
          label: "Billable Invoices",
          sortable: false,
          squeeze: false,
        },
        {
          key: "lines_count",
          label: "Invoice Lines",
          sortable: false,
          squeeze: false,
        },
        {
          key: "correct_lines",
          label: "100% correct suggested Lines",
          sortable: false,
          squeeze: false,
        },
        {
          key: "billable_lines",
          label: "Billable Lines",
          sortable: false,
          squeeze: false,
        },
        {
          key: "summ",
          label: "Billable €",
          sortable: false,
          squeeze: false,
        },
      ],
    };
  },

  methods: {
    getData(_params, config) {
      return ApiCompanies.fetchBilling(this.$route.params.id, config).then(
        (resp) => {
          return {
            items: resp.data.monthes,
          };
        },
      );
    },
  },
};
</script>
